/**
 * Exported so config/app-index.ts can interpolate it into the inline dark-mode
 * bootstrap script — that script runs before hydration and can't import this module,
 * so at least the prefix values themselves have a single source of truth.
 */
export const DARK_MODE_EXCLUDED_PATH_PREFIXES: readonly string[] = ['/admin'];

/**
 * Pages matching DARK_MODE_EXCLUDED_PATH_PREFIXES always render in light mode
 * regardless of the user's dark-mode preference. This is the single source of
 * truth for that exclusion, consumed both server-side (to skip injecting the
 * dark-mode bootstrap script) and client-side (to reconcile the `.dark` class
 * on SPA navigation).
 */
export function isDarkModeExcludedPath(pathname: string): boolean {
	return DARK_MODE_EXCLUDED_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}
